import { NativePanelKey } from '../constants';

/**
 * What a secretary may open. The browser check only decides what to *show*; the gateway applies the same
 * list on the server (a secretary's browser never holds the doctor's token), so a hidden page is also a closed API.
 */
export type SecretaryScope = 'appointments' | 'schedule' | 'vacation';

/** native panel page → the scope that opens it. A page missing here is closed to secretaries (financial, tariffs, settings). */
export const PANEL_KEY_SCOPE: Partial<Record<NativePanelKey, SecretaryScope>> = {
  appointments: 'appointments',
  workhours: 'schedule',
  vacation: 'vacation',
};

export const canSecretaryOpen = (key: NativePanelKey, scopes: readonly SecretaryScope[]) => {
  const scope = PANEL_KEY_SCOPE[key];
  return !!scope && scopes.includes(scope);
};
